import { render, staticRenderFns } from "./manage-examen-fe.html?vue&type=template&id=76638b3e&scoped=true&external"
import script from "./manage-examen-fe.js?vue&type=script&lang=js&external"
export * from "./manage-examen-fe.js?vue&type=script&lang=js&external"
import style0 from "./manage-examen-fe.scss?vue&type=style&index=0&id=76638b3e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76638b3e",
  null
  
)

export default component.exports